import React from 'react';
import PropTypes from 'prop-types';

import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import ShareIcon from '@material-ui/icons/Share';

class DropdownButton extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.handleOpen = this.handleOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);

        this.state = {
            anchorEl: null
        };
    }

    getItems(items) {
        return items.map((item, index) => <MenuItem key={index} onClick={e => this.handleClick(e, item.action)}>{item.label}</MenuItem>);
    }

    handleClose(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({anchorEl: null});
    }

    handleOpen(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({anchorEl: e.currentTarget});
    }

    handleClick(e, action) {
        action();
        this.handleClose(e);
    }

    render() {
        return (
            <IconButton
                disabled={this.props.disabled}
                disableTouchRipple={true}
                onClick={!!this.state.anchorEl ? null : this.handleOpen}
            >
                <ShareIcon/>
                <Menu
                    anchorEl={this.state.anchorEl}
                    open={!!this.state.anchorEl}
                    onClose={this.handleClose}
                >
                    {this.getItems(this.props.items)}
                </Menu>
            </IconButton>
        );
    }
}

DropdownButton.propTypes = {
    disabled: PropTypes.bool,
    items: PropTypes.array.isRequired
};

export default DropdownButton;


// WEBPACK FOOTER //
// ./src/components/common/button/DropdownButton.js